import { FC, PropsWithChildren, useEffect, useMemo, useState } from 'react';
import classnames from 'classnames';
import { Text } from '@servicetitan/anvil2';

import * as Styles from './multiline-text.module.scss';

export interface MultilineTextProps {
    maxLines?: number;
    className?: string;
    onLinesCalculated?: (isTruncated: boolean) => void;
}

export const MultilineText: FC<PropsWithChildren<MultilineTextProps>> = ({
    maxLines,
    children,
    className,
    onLinesCalculated,
}) => {
    const style = useMemo(() => {
        return {
            WebkitLineClamp: maxLines,
        };
    }, [maxLines]);

    const [text, setText] = useState<HTMLSpanElement | null>(null);

    useEffect(() => {
        if (text && !!onLinesCalculated) {
            if (text.scrollHeight > text.clientHeight) {
                onLinesCalculated(true);
            } else {
                onLinesCalculated(false);
            }
        }
    }, [onLinesCalculated, text]);

    return (
        <Text
            size="small"
            className={classnames(Styles.lineClamp, className)}
            style={style}
            ref={(textRef: HTMLElement | null) => setText(textRef)}
        >
            {children}
        </Text>
    );
};
